import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ATS_Frontend } from '../../components/TS_AppTools/index.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import './ATS_ProtoComponent.scss';
import { generateArray } from '@nu-art/ts-common';
import { TS_PropRenderer } from '../../components/TS_PropRenderer/index.js';
import { TS_DropDown } from '../../components/TS_Dropdown/index.js';
import { SimpleListAdapter } from '../../components/adapter/Adapter.js';
import { ProtoComponent } from '../../core/proto-component/index.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { Button } from '../../components/Button/Button.js';
const examples = [
    {
        id: '111',
        str: 'example 1',
        num: 10
    },
    {
        id: '222',
        str: 'example 2'
    },
    {
        id: '333',
        str: 'example 3',
        num: 30
    }
];
export class ATS_ProtoComponent extends ProtoComponent {
    static defaultProps = {
        keys: ['selectedNumber', 'selectedExampleId'],
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.selectedNumber = this.getQueryParam('selectedNumber');
        state.selectedExampleId = this.getQueryParam('selectedExampleId');
        return state;
    }
    static screen = {
        name: 'ProtoComponent',
        key: 'proto-component',
        renderer: this,
        group: ATS_Frontend,
    };
    selectRandomData = () => {
        const selectedNumber = Math.floor(Math.random() * 9);
        const selectedExample = examples[Math.floor(Math.random() * (examples.length - 1))];
        this.setQueryParams({
            selectedNumber,
            selectedExampleId: selectedExample.id
        });
    };
    renderNumberDropDown = () => {
        const numbers = generateArray(10);
        const adapter = SimpleListAdapter(numbers, item => _jsx(_Fragment, { children: item.item }));
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Number Dropdown', children: [_jsx(TS_DropDown, { adapter: adapter, selected: this.state.selectedNumber, onSelected: number => {
                        this.setQueryParam('selectedNumber', number);
                    } }), _jsx(Button, { onClick: () => this.deleteQueryParam('selectedNumber'), children: "Clear Selected Number" })] });
    };
    renderExampleDropDown = () => {
        const adapter = SimpleListAdapter(examples, i => _jsx(_Fragment, { children: i.item.str }));
        const selected = examples.find(i => i.id === this.state.selectedExampleId);
        return _jsxs(_Fragment, { children: [_jsxs(TS_PropRenderer.Vertical, { label: 'Example Dropdown', children: [_jsx(TS_DropDown, { adapter: adapter, selected: selected, onSelected: selected => {
                                this.setQueryParam('selectedExampleId', selected.id);
                            } }), _jsx(Button, { onClick: () => this.deleteQueryParam('selectedExampleId'), children: "Clear Selected Example" })] }), _jsxs(TS_PropRenderer.Vertical, { label: 'Selected Example Data', children: [_jsxs("div", { children: ["id: ", selected?.id ?? '-'] }), _jsxs("div", { children: ["str: ", selected?.str ?? '-'] }), _jsxs("div", { children: ["num: ", selected?.num ?? '-'] })] })] });
    };
    render() {
        return _jsxs(LL_V_L, { id: 'ats-proto-component', children: [_jsx(Button, { onClick: this.selectRandomData, children: "Select Random Data" }), this.renderNumberDropDown(), this.renderExampleDropDown()] });
    }
}
export class ATS_ProtoComponentDouble extends ComponentSync {
    static screen = {
        name: 'ProtoComponent Double',
        key: 'proto-component-double',
        renderer: this,
        group: ATS_Frontend,
    };
    render() {
        return _jsxs(LL_H_C, { children: [_jsx(ATS_ProtoComponent, {}), _jsx(ATS_ProtoComponent, {})] });
    }
}
//# sourceMappingURL=ATS_ProtoComponent.js.map